import { render, staticRenderFns } from "./PopupNotifica.vue?vue&type=template&id=68142a09&scoped=true&"
import script from "./PopupNotifica.vue?vue&type=script&lang=js&"
export * from "./PopupNotifica.vue?vue&type=script&lang=js&"
import style0 from "./PopupNotifica.vue?vue&type=style&index=0&id=68142a09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68142a09",
  null
  
)

export default component.exports